import React, { useEffect, useState } from 'react';
import { message } from 'antd';

import ChooseTime from './components/chooseTime';
import RowTable from './components/rowTable';
import LineChart from './components/lineChart';
import { memberIndicator } from '@/services/chartData';
const MemberData = () => {
  const [rowTableData1, setRowTableData1] = useState([]);
  const [rowTableData2, setRowTableData2] = useState([]);
  const [rowTableData3, setRowTableData3] = useState([]);
  const [lineData, setLineData] = useState([]);
  const [timeRadioValue, setTimeRadioValue] = useState('month');
  const [timeRangeValue, setTimeRangeValue] = useState(['', '']);
  const queryMerchantData = () => {
    let requestData = {};
    if (timeRadioValue === 'date') {
      requestData = {
        startDate: timeRangeValue[0],
        endDate: timeRangeValue[1],
      };
    } else {
      requestData = {
        quickQuery: timeRadioValue,
      };
    }
    memberIndicator({
      requestData: requestData,
    }).then(({ code, msg, data }) => {
      if (code === '00000') {
        setDatas(data);
      } else {
        message.error(msg);
      }
    });
  };
  const setDatas = (data) => {
    setRowTableData1([
      {
        title: '总会员数',
        value: data.userTotal,
        isTailDivider: true,
      },
      {
        title: '历史付费会员数',
        value: data.paid,
        isTailDivider: true,
      },
      {
        title: '历史未付费会员数',
        value: data.neverPaid,
        isTailDivider: true,
      },
      {
        title: '当前有权益会员数',
        value: data.hasRightsCurrently,
        isTailDivider: true,
      },
      {
        title: '当前无权益会员数',
        value: data.noRightsCurrently,
      },
    ]);
    setRowTableData2([
      {
        title: 'LITTA健身月卡',
        value: data.littaMonth,
        isTailDivider: true,
      },
      {
        title: 'LITTA健身年卡',
        value: data.littaAnnual,
        isTailDivider: true,
      },
      {
        title: 'LITTA健身其他',
        value: data.littaOther,
      },
    ]);
    setRowTableData3([
      {
        title: '月卡会员数',
        value: data.liteMonth,
        isTailDivider: true,
      },
      {
        title: '年卡会员数',
        value: data.liteAnnual,
        isTailDivider: true,
      },
      {
        title: '会员卡其他会员数',
        value: data.liteOther,
        isTailDivider: true,
      },
      {
        title: 'PRO付费会员数',
        value: data.aiPaid,
        isTailDivider: true,
      },
      {
        title: 'PRO免费会员数',
        value: data.aiOther,
      },
    ]);
    let arr = [];
    arr = arr
      .concat(
        data.littaMonthTrend.map((i) => {
          return {
            ...i,
            category: 'LITTA健身月卡会员数',
          };
        }),
      )
      .concat(
        data.littaAnnualTrend.map((i) => {
          return {
            ...i,
            category: 'LITTA健身年卡会员数',
          };
        }),
      )
      .concat(
        data.liteMonthTrend.map((i) => {
          return {
            ...i,
            category: 'LITTA私教月卡会员数',
          };
        }),
      )
      .concat(
        data.liteAnnualTrend.map((i) => {
          return {
            ...i,
            category: 'LITTA私教年卡会员数',
          };
        }),
      )
      .concat(
        data.aiPaidTrend.map((i) => {
          return {
            ...i,
            category: 'LITTA私教PRO付费会员数',
          };
        }),
      );
    setLineData(arr);
  };
  useEffect(() => {
    queryMerchantData();
  }, [timeRadioValue, timeRangeValue]);
  const handleTimeChange = (type, value) => {
    if (type === 'date' && value) {
      setTimeRangeValue(value);
    }
    setTimeRadioValue(type);
  };
  return (
    <div>
      <ChooseTime
        timeRadioValue={timeRadioValue}
        onTimeChange={handleTimeChange}
      />
      <RowTable rowTableData={rowTableData1} title="会员构成" />
      <RowTable rowTableData={rowTableData2} title="LITTA健身" />
      <RowTable rowTableData={rowTableData3} title="LITTA私教" />
      <LineChart
        lineData={lineData}
        xField="abscissa"
        yField="ordinate"
        seriesField="category"
      />
    </div>
  );
};

export default MemberData;
